import type { ReactNode } from "react";

/**
 * Content that only works at desktop width — a wide diagram, a positioning
 * chart — with an honest stand-in below the md breakpoint.
 *
 * The children are wrapped in `hidden md:contents` rather than `md:block`, so
 * at desktop the wrapper disappears from the layout entirely and whatever flex
 * or grid classes the children carry keep behaving as they did before. Nothing
 * about the desktop rendering changes by adopting this.
 */
export function DesktopOnly({ children }: { children: ReactNode }) {
  return (
    <>
      <div className="flex items-center justify-center rounded-2xl bg-slate-50 px-6 py-10 text-center ring-1 ring-slate-200 md:hidden">
        <p className="text-sm font-semibold text-slate-500">
          This slide is viewable on desktop
        </p>
      </div>
      <div className="hidden md:contents">{children}</div>
    </>
  );
}
